const validateRealname=(rule,value,callback)=>{
    const reg= /^(([a-zA-Z+.?·?a-zA-Z+]{2,30}$)|([\u4e00-\u9fa5+·?\u4e00-\u9fa5+]{2,30}$))/;
    if(reg.test(value))
    {
        callback();
    } else {
        callback(new Error('真实姓名有误'));
    }
}
const validateTel=(rule,value,callback)=>{
    const pwdZz=/^1[3-9]\d{9}$/;
    if(pwdZz.test(value)){
        callback();
    }
    else
    {
        callback(new Error('手机号码有误'));
    }
}
const validateIdCard=(rule,value,callback)=>{
    const _IDRe18 = /^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
    const _IDre15 =  /^([1-6][1-9]|50)\d{4}\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}$/;
    if(_IDRe18.test(value)||_IDre15.test(value))
    {
        callback();
    } else {
        callback(new Error('身份证号码有误'));
    }
}
export default{
    validateRealname,
    validateTel,
    validateIdCard
};